import { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import TrackVisibility from 'react-on-screen';
import { LiaLaptopCodeSolid } from "react-icons/lia";

import projImg1 from "../asset/img/project-img1.png";
import projImg2 from "../asset/img/project-img2.png";
import projImg3 from "../asset/img/project-img3.png";
import projImg4 from "../asset/img/project-img4.png";
import projGCSC from "../asset/img/project-GCSCApp.png";
import colorSharp2 from "../asset/img/color-sharp2.png";

export const Projects = () => {
  const [flippedCardId, setFlippedCardId] = useState(null);

  const handleCardFlip = (cardId) => {
    setFlippedCardId(flippedCardId === cardId ? null : cardId);
  };

  // Close flipped card when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".flip-card")) {
        setFlippedCardId(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const projects = [
    {
      id: 1,
      title: "🖥️ Responsive Portfolio Website",
      description: "A fully responsive personal portfolio website with advanced animations",
      imgUrl: projImg2,
      technologies: [
        <LiaLaptopCodeSolid size={30} color="white" />,
        " HTML/CSS, JavaScript, React, Bootstrap"
      ]
    },
    {
      id: 2,
      title: "👾 GBA Pong Game",
      description: "An interactive graphical Pong game application that run on a Game Boy Advance emulator",
      imgUrl: projImg3,
      technologies: [
        <LiaLaptopCodeSolid size={30} color="white" />,
        "C"
      ],
      projectUrl: "https://github.com/khaihuyenn/GBA-Game"
    },
    {
      id: 3,
      title: "📱 GCSC App",
      description: "A coaching mobile application designed to enhance physical and emotional growth for student-athletes",
      imgUrl: projGCSC,
      technologies: [
        <LiaLaptopCodeSolid size={30} color="white" />,
        "TypeScript, React Native, Node.js, PosgreSQL, Supabase"
      ],
      projectUrl: "https://drive.google.com/file/d/1o5itWIDGhoUUAPQQGFp7BUJhwDBMNDyc/view?usp=share_link"
    },
    {
      id: 4,
      title: "🤖 Sentiment Analysis",
      description: "ML models to analyze the sentiment of financial news headlines using Naive Bayes, NN, SVM, Random Forest algorithms.",
      imgUrl: projImg4,
      technologies: [
        <LiaLaptopCodeSolid size={30} color="white" />,
        "Python, scikit-learn, Numpy, Matplotlib"
      ],
      projectUrl: "https://khaihuyenn.github.io/sentiment_analysis.github.io/"
    },
    {
      id: 5,
      title: "👾 2D Dungeon Crawler game",
      description: "Collaborate with a team implementing and writing unit tests across five sprints to develop a 2D Dungeon Crawler game",
      imgUrl: projImg1,
      technologies: [
        <LiaLaptopCodeSolid size={30} color="white" />,
        "Java, Android Studio Code"
      ]
    }
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div defaultActiveKey="first">
                <h2>Projects</h2>
                <p></p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Personal Project</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Group Project</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Future Project</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="projects-tabs" defaultActiveKey="first">
                    <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project) => {
                            if (project.id === 1 || project.id === 2) {
                              return (
                                <ProjectCard
                                  key={project.id}
                                  {...project}
                                  isFlipped={flippedCardId === project.id}
                                  onFlip={() => handleCardFlip(project.id)}
                                />
                              );
                            }
                            return null;
                          })}
                        </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                        <Row>
                          {projects.map((project) => {
                            if (project.id === 3 || project.id === 4 || project.id === 5) {
                              return (
                                <ProjectCard
                                  key={project.id}
                                  {...project}
                                  isFlipped={flippedCardId === project.id}
                                  onFlip={() => handleCardFlip(project.id)}
                                />
                              );
                            }
                            return null;
                          })}
                        </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <h5>💭...</h5>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="background"></img>
    </section>
  );
};